import { Outlet, createRootRoute } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/router-devtools";

import { AppLoading } from "@/components/app-loading";
import { NotFoundPage } from "@/components/not-found-page";
import { usePageTracking } from "@/hooks/use-page-tracking";

export const Route = createRootRoute({
  component: () => Root(),
  notFoundComponent: () => NotFoundPage()
});

const Root = () => {
  usePageTracking();
  return (
    <AppLoading>
      <div className="bg-background-primary fixed top-0 left-0 w-full h-full z-[-1]" />
      <div className="relative flex flex-col h-screen w-full">
        <Outlet />
      </div>
      <TanStackRouterDevtools />
    </AppLoading>
  );
};
